// extracted by mini-css-extract-plugin
export default {"switch":"GEsrMa","active":"vvfDqr","handle":"ENdWD7","size-30":"Q7lSJL"};